export default "__VITE_PUBLIC_ASSET__e2ed2939__"